import {register} from '../../../assets/js/modules/eventMap';

const init = () => window.print();

const printDialog = () => {
    register('printDialog', {init});
};

export {printDialog};
